function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.16 18.68a6.5 6.5 0 1 0-.13.13l.06-.07zm2 .73l4.53 4.53a1 1 0 0 1-1.42 1.42l-4.53-4.53a8.49 8.49 0 1 1 1.42-1.42z",
  fill: "#fff",
  "data-name": "Audit"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPlRlYW0gQXVkaXQ8L3RpdGxlPgogIDxnIGZpbGw9J3doaXRlJyBpZD0iOGFiYjhiZGMtOTZiYi00NWFjLTgxNjctNjQ3OTdjZWU4ZTcwIiBkYXRhLW5hbWU9IkF1ZGl0Ij4KICAgIDxwYXRoIGQ9Ik0xOS4xNiwxOC42OGE2LjUsNi41LDAsMSwwLS4xMy4xM2wuMDYtLjA3Wm0yLC43Myw0LjUzLDQuNTNhMSwxLDAsMCwxLTEuNDIsMS40MmwtNC41My00LjUzYTguNDksOC40OSwwLDEsMSwxLjQyLTEuNDJaIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgComponent as ReactComponent };